<template>
  <div class="card">
    <div class="field-item van-hairline--bottom">
      <div class="field-item-title bold">裂变佣金</div>
      <!-- <van-switch
        v-model="form.boolFissionRewardEnabled"
        size="24px"
        active-color="#FF6B31"
        inactive-color="#f4f4f4"
      /> -->
      <van-radio-group v-model="form.boolFissionRewardEnabled" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
        <van-radio :name="false">关闭</van-radio>
        <van-radio :name="true" @click="changeFission">开启</van-radio>
      </van-radio-group>
    </div>
    <template v-if="form.boolFissionRewardEnabled">
      <van-field
        class="fee-value text-input"
        v-model="form.maxFissionNum"
        label="本场活动单人最高裂变人数"
        label-width="13.5em"
        placeholder="请输入"
        type="digit"
				@blur="onMaxFissionNumChange('maxFissionNum')"
      >
        <span slot="right-icon">人</span>
      </van-field>
      <van-field
        class="fee-value text-input"
        v-model="form.fissionAmount"
        label="裂变佣金"
        label-width="7.8em"
        placeholder="最小0.3元保留两位小数"
        type="number"
        @blur="checkFeeValid('fissionAmount')"
      >
        <span slot="right-icon">元</span>
      </van-field>
			<div class="field-item">
				<div class="field-item-title bold">地理限制</div>
				<!-- <van-switch v-model="form.boolAreaLimited" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4"/> -->
        <van-radio-group v-model="form.boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
			</div>
			<div class="tips tips-bg van-hairline--bottom">开启地理位置限制后，仅限分享职员所在市区才能领取红包</div>
			<div class="field-item">
				<div class="field-item-title bold">领取轮播</div>
				<!-- <van-switch v-model="form.boolFissionRolling" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4"/> -->
        <van-radio-group v-model="form.boolFissionRolling" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
			</div>
			<div class="tips tips-bg van-hairline--bottom">开启后将会在页面最上方进行展示</div>
			<div class="field-item">
				<div class="field-item-title bold">屏蔽内部职员</div>
				<!-- <van-switch v-model="form.boolInternalStaffLimit" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4"/> -->
        <van-radio-group v-model="form.boolInternalStaffLimit" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
			</div>
			<div class="tips tips-bg van-hairline--bottom">开启后，红包百分比不中奖，裂变佣金不发放</div>
			<van-field
        class="fee-value text-input"
        v-model="form.totalAmount"
        label="首次充值金额"
        label-width="7em"
        placeholder="最小0.3元，保留两位小数"
        type="number"
        :readonly="isReadonly"
        @blur="checkFeeValid('totalAmount')"
      >
        <span slot="right-icon">元</span>
      </van-field>
    </template>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
export default {
	model: {
    prop: 'value',
    event: 'change'
  },
	props: {
		value: {
			type: Object,
			default() {
				return {}
			}
		},
    // 1:创建  2:附加
    sourceType: Number,
    // 是否已配置了裂变
    isConfigFission: Boolean,
    createdTime: [String,Number]
	},
	computed: {
		form: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('change', val)
			}
		},
    isReadonly() {
      return this.$route.query.activityStatus == 3 || (this.sourceType == 2 && this.isConfigFission);
    },
     // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
	},
  data() {
    return {
      withdrawConfig: {},
    };
  },
  created() {
    this.queryPublicityData()
  },
  methods: {
    changeFission() {
      // if (this.creationMode) {
        const {openRechargeAndWithdraw, time} = this.withdrawConfig
        let createdTime = this.sourceType != 2 ? new Date().getTime() : new Date(this.createdTime).getTime()
        const isNewActive = createdTime > new Date(time).getTime()
        if (openRechargeAndWithdraw === 'false' && isNewActive) {
          this.form.boolFissionRewardEnabled = false
          this.$dialog.alert({
            title: '提示',
            message: '系统维护中当前不可配置裂变佣金',
          })
            .then(() => {
              // on confirm
            })
        // }
      }
    },
		onMaxFissionNumChange(fieldName) {
      const model = this.form;
      const fieldValue = model[fieldName];
      model[fieldName] = round2Places(fieldValue)
      if (+this.form.maxFissionNum < 1) {
        this.form.maxFissionNum = 1;
      }
      if (+this.form.maxFissionNum > 6) {
        this.form.maxFissionNum = 6;
      }
    },
    checkFeeValid(fieldName) {
      const model = this.form;
      const fieldValue = model[fieldName];
      model[fieldName] = fieldValue < 0.3 ? 0.3 : round2Places(fieldValue);
    },
    checkout() {
      let isPass = false
      const {boolFissionRewardEnabled,maxFissionNum,fissionAmount,totalAmount} = this.form
      if (boolFissionRewardEnabled) {
        if (!maxFissionNum) {
          this.$toast('请输入本场活动单人最高裂变人数')
        }else if (!fissionAmount) {
          this.$toast('请输入裂变佣金')
        }else if (!totalAmount) {
          this.$toast('请输入首次充值金额')
        }else {
          isPass = true
        }
      }else {
        isPass = true
      }
      return isPass
    },
    queryPublicityData(){
      this.$api.h5.queryPublicityData('wx_withdraw_config')
        .then(res => {
          if (res.success) {
            const {openRechargeAndWithdraw, time} = res.data
            this.withdrawConfig = {openRechargeAndWithdraw,time}
          }
          
        })
    }
  },
};
</script>

<style lang="stylus" scoped>
.card
  margin 15px
  overflow: hidden
  border-radius: 8px

.field-item
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    color #323233
		font-weight 600

.fee-value
  >>> .van-cell__value input
    text-align: right

.range-card
  margin 15px 0
  padding 10px 16px
  background-color: #fff
  border-radius: 8px
  &-head
    padding-bottom 10px
    display: flex
    justify-content: space-between
    font-size 14px
    font-weight 600

.range-field
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 0
  font-size 14px
  &-label
    color #606266
    flex none
  &-content
    display: flex
    align-items: center
    justify-content: space-around

    >span
      margin 0 10px

    .range-input
      padding 0
      line-height 1
      &::after
        border-bottom: none
      >>> .van-field__body
        width 105px
        input
          border-bottom: 1px solid #ebedf0
          text-align: center
.tips
  padding 0 16px 5px
  font-size 12px
  color #bbb
  text-align: right
.tips-bg
  background-color: #fff
</style>
